import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Footer() {
  const footerLinks = [
    { label: '关于我们', href: '/about' },
    { label: '用户协议', href: '/about' },
    { label: '隐私政策', href: '/about' },
    { label: '版权声明', href: '/about' },
    { label: '帮助中心', href: '/about' },
    { label: '意见反馈', href: '/about' },
  ];

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">密桃视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              密桃视频是一款汇聚海量高清短视频内容的视频平台，涵盖娱乐、生活、搞笑、美食、旅行等多元类别，为用户提供流畅播放体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">contact@mitaovideo.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">400-888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">北京市朝阳区望京科技园</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 密桃视频 版权所有 | 京ICP备20260810001号
          </p>
          <p className="text-xs text-background-500">
            用心发现每一份精彩
          </p>
        </div>
      </div>
    </footer>
  );
}